import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '/home',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/Taller',
    name: 'Taller',
    component: () => import('../views/Taller.vue')
  },
  {
    path: '/Tarifas',
    name: 'Tarifas',
    component: () => import('../views/Tarifas.vue')
  },
  {
    path: '/Calendario',
    name: 'Calendario',
    component: () => import('../views/Calendario.vue')
  },
  {
    path: '/Reservas',
    name: 'Reservas',
    component: () => import('../views/Reservas.vue')
  },

  {
    path: '/Presupuestos',
    name: 'Presupuestos',
    component: () => import('../views/Presupuestos.vue')
  },
  
  {
    path: '/Clientes',
    name: 'Clientes',
    component: () => import('../views/Clientes.vue')
  },
  {
    path: '/Bicis',
    name: 'Bicis',
    component: () => import('../views/Bicis.vue')
  },

  {
    path: '/Mensajes',
    name: 'Mensajes',
    component: () => import('../views/Mensajes.vue')
  },

  {
    path: '/Ingresos',
    name: 'Ingresos',
    component: () => import('../views/Ingresos.vue')
  },
 
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
